interface ReasoningSubDescriptionProps {
    text: string | null;
}

export function ReasoningSubDescription({
    text,
}: ReasoningSubDescriptionProps) {
    if (!text) return null;
    return (
        <p
            key={text}
            className="pl-6 pr-4 pb-2 max-w-[68ch] min-h-[2.5rem] text-sm italic leading-relaxed text-grey-400 animate-fadeIn"
        >
            {text}
        </p>
    );
}
